import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";

import Logo from "./Logo";
import ProfileMenu from "./Profile/ProfileMenu";
import ProfileModal from "./Profile/ProfileModal";
import tokenUtils from "../../utils/tokenUtils";
import "./header.scss";

const decodeJwt = (token) => {
  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch {
    return null;
  }
};

const Header = ({ showLogout, onLogout }) => {
  const navigate = useNavigate();

  const [profileOpen, setProfileOpen] = useState(false);
  const [adminDetails, setAdminDetails] = useState(null);

  useEffect(() => {
    if (showLogout) {
      const token = tokenUtils.getToken();
      // if(token) console.log("decoded jwt", decodeJwt(token));
      setAdminDetails(token ? decodeJwt(token) : null);
    } else {
      setAdminDetails(null);
    }
  }, [showLogout]);

  const handleViewProfile = () => {
    setProfileOpen(true);
  };

  const handleCloseProfile = () => {
    setProfileOpen(false);
  };

  return (
    <>
      <AppBar position="static" elevation={0} className="header">
        <Toolbar
          disableGutters
          sx={{
            width: "100%",
            minHeight: "80px !important",
            justifyContent: "space-between",
          }}
        >
          <Box
            className="header-logo"
            onClick={() => navigate("/home/manage-student")}
          >
            <Logo />
          </Box>

          <Box sx={{ flexGrow: 1 }} />

          {showLogout && (
            <ProfileMenu
              adminDetails={adminDetails}
              onViewProfile={handleViewProfile}
              onLogout={onLogout}
            />
          )}
        </Toolbar>
      </AppBar>

      <ProfileModal
        open={profileOpen}
        onClose={handleCloseProfile}
        adminDetails={adminDetails}
      />
    </>
  );
};

export default Header;
